import { FC } from "react";
import cx from "classnames";

import { selectOwner } from "./../../../../store/collaborators/selectors";
import useShallowSelector from "./../../../../hooks/useShalowSelector";

import styles from "./styles.module.scss";

interface IProps {
    withCollaborators: boolean;
}

const OwnerItem: FC<IProps> = ({ withCollaborators }) => {
    const { email } = useShallowSelector(selectOwner);

    return (
        <div
            className={cx(styles.ownerInfo, {
                [styles.withCollaborators]: withCollaborators,
            })}
        >
            <span>{email}</span>
            <span className={styles.role}>Owner</span>
        </div>
    );
};

export default OwnerItem;
